// Combines all reducers from module slices into one reducer.
import {combineReducers} from '@reduxjs/toolkit';

const moduleSlices = import.meta.webpackContext(
    './',
    {recursive: true, regExp: /\.\/\w+\/slice(.js|\/index.js)/, mode: 'sync'}
);

export default combineReducers(
    moduleSlices.keys().reduce((memo, key) => {
        let slice = moduleSlices(key);
        if (slice.default) {
            slice = slice.default;
        }

        // Only add if it's a function.
        if (slice.name && typeof slice.reducer == 'function') {
            memo[slice.name] = slice.reducer;
        }
        return memo;
    }, {}),
);
